import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-processing',
  templateUrl: './wait-processing.component.html',
  styleUrls: ['./wait-processing.component.css']
})
export class WaitProcessingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/wait-processing/wait-processing.component.ts